import ApiService from "@/service/api";

export const PaymentService = {

    getTransactionHistory() {
        return ApiService.get("/external/transactions");
    }
};
